import * as Sentry from '@sentry/react';
import { DGLayout } from '@tf/ui';
import { BrowserRouter } from 'react-router-dom';
import { useEnableConfigurationPreview } from '@/components/internal-tools/configurationPreview';
import { AmplitudeInitialization, AppProvider, SentryInitialization } from '@/core/providers';
import { Router } from '@/routes/index';

// import for side effect - add Mantine CSS
import '@tf/ui/lib/providers/MantineStyles';

export const App = () => {
	useEnableConfigurationPreview();

	return (
		<Sentry.ErrorBoundary
			beforeCapture={(scope) => {
				scope.setTag('location', 'global');
			}}
			fallback={() => <VanillaInitializationError />}
		>
			<DGLayout>
				{/* the router wraps the providers so Clerk can navigate without full page reloads */}
				<BrowserRouter>
					<AppProvider>
						<SentryInitialization />
						<AmplitudeInitialization />
						<Router />
					</AppProvider>
				</BrowserRouter>
			</DGLayout>
		</Sentry.ErrorBoundary>
	);
};

// we don't have a Mantine/Emotion provider at the top-level error boundary, so we're using plain css for this component
const VanillaInitializationError = () => {
	return (
		<div className="container">
			<div className="error-box">
				<div className="icon">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M28.3333 36.6668V33.3335M15 25.0002L25 15.0002M18.3333 10.0003L19.105 9.10693C20.668 7.54414 22.7878 6.66627 24.9981 6.66642C27.2084 6.66658 29.3281 7.54476 30.8908 9.10777C32.4536 10.6708 33.3315 12.7906 33.3314 15.0009C33.3312 17.2111 32.453 19.3308 30.89 20.8936L30 21.6669M21.6669 30.0002L21.0052 30.8902C19.424 32.4538 17.2899 33.3308 15.0661 33.3308C12.8423 33.3308 10.7082 32.4538 9.12691 30.8902C8.34751 30.1195 7.72874 29.2019 7.30643 28.1904C6.88413 27.1789 6.66668 26.0937 6.66668 24.9977C6.66668 23.9016 6.88413 22.8164 7.30643 21.8049C7.72874 20.7935 8.34751 19.8758 9.12691 19.1052L10.0002 18.3335M33.3333 28.3335H36.6667M3.33334 11.6668H6.66668M11.6667 3.3335V6.66683"
							stroke="#111827"
							strokeWidth="3"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<h3 className="title">Initialisation error</h3>
				<p className="message">An error occurred during initialisation of the application.</p>
				<a className="link" href="mailto:support@trustform.io">
					<span className="link-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clipPath="url(#clip0_2282_150)">
								<path
									d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7M3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7M3 7L12 13L21 7"
									stroke="#2563EB"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
							<defs>
								<clipPath id="clip0_2282_150">
									<rect width="24" height="24" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</span>
					<span>Contact support</span>
				</a>
			</div>
		</div>
	);
};
